module.exports = __webpack_public_path__ + "static/media/david.20ae9f68.jpg";